import type { Money } from "@graphql/generated/types";
import type { SaleBadge } from "@lib/wrappers/algolia/types";

/**
 * Supported Algolia Recommend models.
 */
export const AlgoliaRecommendModel = {
    RELATED_PRODUCTS: "related-products",
    LOOKING_SIMILAR: "looking-similar",
    BOUGHT_TOGETHER: "bought-together",
    TRENDING_ITEMS: "trending-items",
} as const;

export type AlgoliaRecommendModel =
    (typeof AlgoliaRecommendModel)[keyof typeof AlgoliaRecommendModel];

/**
 * Slimmed down swatch object for product recommendations, optimized for server-side fetching and minimal payload.
 */
export interface SlimSwatch {
    objectID: string;
    colorCode: string;
    image: string;
    dominantColor: string;
    backgroundColor: string;
    hasStock: boolean;
    priceWithDiscount: Money;
    priceWithoutDiscount: Money;
    discountPercentage: number;
    eaBadge?: SaleBadge;
    customBadges?: string[];
}

export interface RecommendationResult {
    objectID: string;
    productColors: SlimSwatch[];
    eaBadge?: SaleBadge;
    badges?: string[];
}

interface AlgoliaPrice {
    centAmount: number;
    currencyCode: string;
    fractionDigits: number;
}

export interface AlgoliaColorHit {
    objectID: string;
    colorCode: string;
    image: string;
    dominantColor: string;
    backgroundColor: string;
    hasStock: boolean;
    priceRaw: AlgoliaPrice;
    listPriceRaw: AlgoliaPrice;
    discountPercentage: number;
    eaBadge?: SaleBadge;
    badges?: string[];
    customBadges?: string[];
}

export interface AlgoliaHit {
    objectID: string;
    productColors?: AlgoliaColorHit[];
    eaBadge?: SaleBadge;
    badges?: string[];
}
